import React, { Component } from 'react';
import './Account.css';
import PropTypes from 'prop-types';
import adminIconPng from 'images/spackle-icon.png';
import { ServiceProviderTypes } from 'domain/service-provider-type-enum';

class Account extends Component {
  static propTypes = {
    account: PropTypes.shape({}).isRequired,
  };

  render() {
    const { account } = this.props;
    return (
      <div className="account">
        <div className="account-icon-container">
          {!account.accountable_id ? (
            <div className="icon with-icon">
              <img src={adminIconPng} alt="user-icon" />
            </div>
          ) : (
            <div className="icon no-icon">
              {(account.first_name || '').charAt(0)}
              {(account.last_name || '').charAt(0)}
            </div>
          )}
        </div>

        <div className="account-content-container">
          <div className="account-name">
            {account.first_name} {account.last_name} -{' '}
            {ServiceProviderTypes[account.accountable_type] || 'Spackle'}
          </div>
          <div className="account-contact">{account.email}</div>
        </div>
      </div>
    );
  }
}

export default Account;



// WEBPACK FOOTER //
// ./src/components/header/Account.js